import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

let unique = 0;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'documents-illustration',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent {
  private unique: number;

  constructor(readonly location: Location) {
    this.unique = unique++;
  }

  id(id: string) {
    return `${id}-${this.unique}`;
  }

  url(id: string) {
    return `url(${this.location.path()}#${this.id(id)})`;
  }
}
